var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnhandledError = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 317.7 233.9",
  style: {
    enableBackground: "new 0 0 317.7 233.9"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill:#EEEEEE;}\r\n\t.st1{fill:#5793CE;}\r\n\t.st2{fill:#396CAA;}\r\n\t.st3{fill:#D4ECFF;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#173D7A;}\r\n\t.st6{fill:#EFEFEF;}\r\n\t.st7{fill:#FAFDFF;}\r\n\t.st8{opacity:0.4;fill:#D4ECFF;enable-background:new    ;}\r\n\t.st9{fill:#274F89;}\r\n\t.st10{fill:#FF2C9C;}\r\n\t.st11{fill:#D3008D;}\r\n\t.st12{fill:#C90000;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2525"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14026",
  className: "st0",
  d: "M151,225.1c-59.8,24.1-155.9-4.3-150.8-51c3-27.6,11.9-50,62.7-80.1 c36-21.3-8.2-46.8,26.8-63.8s129.3-56.6,206.2,17.2C376.7,124.9,210.8,201,151,225.1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2023"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1937"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1925"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13613",
  className: "st1",
  d: "M214.7,70.9c-0.3,0-0.5-0.2-0.5-0.5V48.6c-0.1-0.3,0-0.6,0.3-0.7c0.3-0.1,0.6,0,0.7,0.3 c0,0.1,0,0.2,0,0.4l0,0v21.8C215.2,70.6,215,70.9,214.7,70.9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1924"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1922"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_847",
  x: 212.8,
  y: 47.2,
  className: "st1",
  width: 3.8,
  height: 8.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13614",
  className: "st1",
  d: "M216.1,56.1c-0.8,0.4-1.8,0.4-2.7,0c-0.4-0.1-0.7-0.6-0.5-1c0.1-0.2,0.3-0.4,0.5-0.5 c0.8-0.4,1.8-0.4,2.7,0c0.4,0.2,0.6,0.6,0.5,1C216.5,55.8,216.3,56.1,216.1,56.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1923"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_848",
  x: 211.7,
  y: 35.8,
  className: "st1",
  width: 6.1,
  height: 12.8
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13615",
  className: "st2",
  d: "M212.8,48.6v2.8c1.2,0.5,2.6,0.5,3.8,0v-2.8C215.4,48.1,214.1,48.1,212.8,48.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13616",
  className: "st1",
  d: "M216.9,49.9c-1.4,0.7-3,0.7-4.3,0c-0.7-0.2-1.1-1-0.8-1.7c0.1-0.4,0.4-0.7,0.8-0.8 c1.4-0.7,3-0.7,4.3,0c0.7,0.2,1.1,1,0.8,1.7C217.6,49.4,217.3,49.7,216.9,49.9z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1929"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13617",
  className: "st1",
  d: "M236,82.9c-0.3,0-0.5-0.2-0.5-0.5V60.6c0-0.3,0.2-0.5,0.5-0.5c0,0,0,0,0,0 c0.3,0,0.5,0.2,0.5,0.5v21.8C236.5,82.6,236.3,82.9,236,82.9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1928"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1926"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_849",
  x: 234.1,
  y: 59.2,
  className: "st1",
  width: 3.8,
  height: 8.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13618",
  className: "st1",
  d: "M237.4,68.1c-0.8,0.4-1.8,0.4-2.7,0c-0.4-0.2-0.6-0.6-0.5-1c0.1-0.2,0.3-0.4,0.5-0.5 c0.8-0.4,1.8-0.4,2.7,0c0.4,0.1,0.6,0.6,0.5,1C237.8,67.8,237.6,68,237.4,68.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1927"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_850",
  x: 232.9,
  y: 47.8,
  className: "st1",
  width: 6.1,
  height: 12.8
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13619",
  className: "st2",
  d: "M234.1,60.5v2.8c1.2,0.5,2.6,0.5,3.8,0v-2.8C236.7,60,235.3,60,234.1,60.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13620",
  className: "st1",
  d: "M238.2,61.8c-1.4,0.7-3,0.7-4.3,0c-0.7-0.2-1.1-1-0.8-1.7c0,0,0,0,0,0 c0.1-0.4,0.4-0.7,0.8-0.8c1.4-0.7,3-0.7,4.3,0c0.7,0.2,1.1,1,0.8,1.7C238.9,61.4,238.6,61.7,238.2,61.8z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1936"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1932"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13621",
  className: "st1",
  d: "M256.7,69l8.2-4.8l-7.8-9.8l-2.1,3.4L256.7,69z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13622",
  className: "st1",
  d: "M196.9,15.3L210,7.8c0,0-0.5,7.6-0.5,7.6s-7.6,2.3-7.6,2.3L196.9,15.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13623",
  className: "st1",
  d: "M259,44.4c-0.9-0.5-1.8-0.9-2.8-1c-1.3-7-6.2-14.4-12-17.7c-1.5-0.9-3.2-1.5-4.9-1.6 c-0.8-8.4-6.7-18-13.8-22.1c-3.7-2.2-7.1-2.4-9.6-1.1l0,0l-0.1,0.1L215.6,1l-7.7,4.6l2.6,2c-2.3,1-3.8,3.6-3.8,7.4 c0,7.1,5,15.7,11.1,19.2L259,63.6c4.6,2.7,8.3,0.5,8.3-4.8S263.6,47.1,259,44.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13624",
  className: "st1",
  d: "M207.1,11.9l17.8-10.4c-3.4-1.8-6.6-2-8.9-0.7l0,0l-0.1,0.1L215.6,1l-7.8,4.6l2.6,2 C208.7,8.4,207.4,10,207.1,11.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13625",
  className: "st1",
  d: "M239.9,42.5l13-7.6c-2.1-3.7-5-6.9-8.7-9.2c-0.5-0.3-0.9-0.5-1.3-0.7l-16.5,9.6 L239.9,42.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13626",
  className: "st3",
  d: "M211.5,6.4l5.8,3.3l10.6-6.2c-0.8-0.6-1.6-1.1-2.4-1.6c-1.2-0.7-2.4-1.2-3.7-1.6 L211.5,6.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13627",
  className: "st3",
  d: "M251.4,32.6l-10.4,6.1l3.6,4l9.4-5.5C253.3,35.5,252.5,34,251.4,32.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13628",
  className: "st3",
  d: "M250.8,49.2c-0.9-0.5-1.8-0.8-2.9-1c-1.3-7-6.2-14.4-11.9-17.7c-1.5-0.9-3.2-1.5-4.9-1.7 c-0.8-8.4-6.7-18-13.8-22.1c-7.7-4.4-13.9-0.8-13.9,8c0,0.3,0,0.6,0,0.9c-5.6-2.6-10,0.3-10,7c0,7.1,5,15.7,11.1,19.2 l46.2,26.7c4.6,2.7,8.3,0.5,8.3-4.8S255.4,51.9,250.8,49.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1930"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13629",
  className: "st4",
  d: "M203.5,15.6c0-0.3,0-0.6,0-0.9l0,0c-3.1-1.2-5.8-0.7-7.4,1.2 C197.9,14.4,200.5,14.2,203.5,15.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13630",
  className: "st4",
  d: "M251.5,48.6c-0.9-0.5-1.8-0.8-2.9-1c-1.3-7-6.2-14.4-11.9-17.7c-1.5-0.9-3.2-1.5-4.9-1.7 c-0.8-8.4-6.7-18-13.8-22.1c-4.8-2.8-9-2.4-11.5,0.4c2.5-2.2,6.4-2.3,10.8,0.3c7.1,4.1,13,13.7,13.8,22.1 c1.7,0.2,3.4,0.7,4.9,1.7c5.8,3.3,10.6,10.7,12,17.7c1,0.2,2,0.5,2.8,1c4.6,2.7,8.3,9.1,8.3,14.4c0.1,1.6-0.4,3.2-1.3,4.4 c1.2-1,2-2.7,2-5.1C259.8,57.7,256.1,51.2,251.5,48.6z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1931"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13631",
  className: "st2",
  d: "M202.6,17.7l3.5,1.6l-0.2-3.8c0-0.3,0-0.5,0-0.8c0-3.4,1-5.9,2.9-7s4.5-0.7,7.5,1 c6.4,3.7,11.9,12.6,12.6,20.4l0.2,2l2,0.2c1.4,0.1,2.7,0.6,3.9,1.3c5.1,2.9,9.6,9.7,10.8,16.1l0.3,1.6l1.6,0.2 c0.7,0.1,1.4,0.4,2,0.8c3.9,2.2,7.2,7.9,7.2,12.4c0,1.7-0.5,2.9-1.3,3.4c-0.8,0.5-2.1,0.2-3.6-0.6l-46.2-26.7 c-5.4-3.1-9.9-11-9.9-17.2c0-2.4,0.7-4.3,2-5.1c0.5-0.3,1.2-0.5,1.8-0.5C200.7,17,201.7,17.3,202.6,17.7z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1935"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13632",
  className: "st1",
  d: "M225.6,46.7l1.2-0.6l-1.2-0.9L225.6,46.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13633",
  className: "st1",
  d: "M222,30.2l1.2-0.6v0.6L222,30.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13634",
  className: "st1",
  d: "M229.1,42.8l1.2-0.6l-2.4-2.3L229.1,42.8z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1933"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13635",
  className: "st1",
  d: "M226.5,46l-5.8-3.4c-0.3-0.2-0.5-0.6-0.5-1v-6.7l6.8,4v6.7C227,46,226.8,46.2,226.5,46z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13636",
  className: "st1",
  d: "M223.1,29.6l-6.2,4c-0.3,0.2,0,0.8,0.4,1l6.4,3.8l6.4,3.8c0.4,0.2,0.6-0.1,0.4-0.6 l-6.2-11.3C223.9,29.7,223.4,29.4,223.1,29.6z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1934"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13637",
  className: "st3",
  d: "M225.2,46.6l-5.8-3.4c-0.3-0.2-0.5-0.6-0.5-1v-6.7l6.8,4v6.7 C225.8,46.7,225.5,46.8,225.2,46.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13638",
  className: "st3",
  d: "M221.9,30.2l-6.2,4c-0.3,0.2-0.1,0.8,0.4,1l6.4,3.8l6.3,3.8c0.4,0.2,0.6-0.1,0.4-0.6 l-6.2-11.3C222.6,30.3,222.2,30.1,221.9,30.2z"
})))), /*#__PURE__*/React.createElement("path", {
  id: "Path_13639",
  className: "st3",
  d: "M214.2,54c0,0.4-0.3,0.5-0.6,0.3c-0.3-0.2-0.6-0.6-0.6-1c0-0.4,0.3-0.5,0.6-0.3 C213.9,53.2,214.1,53.5,214.2,54z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13640",
  className: "st3",
  d: "M235.5,66.1c0,0.4-0.3,0.5-0.6,0.3c-0.3-0.2-0.6-0.6-0.6-1c0-0.4,0.3-0.5,0.6-0.3 C235.2,65.3,235.5,65.7,235.5,66.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2016"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1942"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13641",
  className: "st1",
  d: "M51.6,139.3l-0.2-0.3v1.3l0,0c-0.1,2.1,1.3,4.3,4.1,5.9l13.3,7.7l5.6-3.2L61.1,143 c-0.6-0.3-1.2-0.8-1.6-1.5c-3-0.2-5.3-1.8-7.4-3.7C51.9,138.3,51.7,138.8,51.6,139.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13642",
  className: "st5",
  d: "M90.4,97.2c-5.5-3.2-14.5-3.2-20.1,0l-13.2,7.6c-1.4,0.8-2.6,1.9-3.4,3.3 c2.2,2,4.2,4.2,7.6,3.9c-0.9-1.3-0.4-2.9,1.4-3.9l13.2-7.6c2.8-1.4,6.2-1.4,9,0l8.5,4.9l5.6-3.2L90.4,97.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13643",
  className: "st1",
  d: "M75.4,120.9c-0.7-0.6-1.4-1.2-2.2-1.6l-10.5-6.1c-0.6-0.3-1-0.7-1.4-1.2 c-3.3,0.3-5.4-1.9-7.6-3.9c-0.2,0.4-0.4,0.8-0.5,1.3l-0.2-0.2v1.4l0,0c0,2.1,1.4,4.2,4.2,5.8l10.5,6.1c1.6,0.9,2.2,2.3,1.7,3.5 C71.5,125.4,73.2,122.7,75.4,120.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13644",
  className: "st5",
  d: "M77.2,123.9c-0.3-1.1-0.9-2.2-1.8-3c-2.1,1.8-3.8,4.5-6,5.1c-0.4,0.7-0.9,1.4-1.7,1.7 l-12.1,7c-1.4,0.8-2.6,1.9-3.4,3.2c2.1,1.9,4.4,3.5,7.4,3.7c-0.7-1.2-0.1-2.7,1.6-3.7l12.1-7c2.7-1.6,4.1-3.7,4.1-5.7l0,0v-1.4 L77.2,123.9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1938"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13645",
  className: "st4",
  d: "M57.1,114.9l10.6,6.1c0.9,0.4,1.6,1.3,1.8,2.3c0.1-1-0.5-2.1-1.8-2.9l-10.5-6.1 c-2.6-1.5-4-3.5-4.1-5.5C52.9,111,54.2,113.3,57.1,114.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13646",
  className: "st4",
  d: "M68.9,151.9l-13.3-7.7c-2.6-1.5-4-3.5-4.1-5.5c-0.1,2.2,1.2,4.4,4.1,6.1l13.3,7.7l5.6-3.2 l-0.5-0.3L68.9,151.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13647",
  className: "st4",
  d: "M93.4,103.2l-8.5-4.9c-2.8-1.4-6.2-1.4-9,0L62.7,106c-1.4,0.8-2,1.8-1.8,2.9 c0.2-1,0.9-1.8,1.8-2.3L75.9,99c2.8-1.4,6.2-1.4,9,0l8.5,4.9l5.6-3.2l-0.5-0.3L93.4,103.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13648",
  className: "st4",
  d: "M73.2,128.8l-12.1,7c-1.4,0.8-2,1.9-1.8,2.9c0.2-1,0.9-1.9,1.8-2.3l12.1-7 c2.9-1.7,4.3-3.9,4.1-6.1C77.2,125.3,75.8,127.3,73.2,128.8z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1941"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1939"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13649",
  className: "st3",
  d: "M68.9,152.5l-13.3-7.7c-5.5-3.2-5.5-8.4,0-11.6l12.1-7c2.5-1.4,2.5-3.8,0-5.2l-10.5-6.1 c-5.5-3.2-5.5-8.4,0-11.6l13.2-7.6c5.5-3.2,14.5-3.2,20.1,0l8.5,4.9l-5.5,3.2l-8.5-4.9c-2.8-1.4-6.2-1.4-9,0l-13.2,7.7 c-2.5,1.4-2.5,3.8,0,5.2l10.5,6.1c5.5,3.2,5.5,8.4,0,11.6l-12.1,7c-2.5,1.4-2.5,3.8,0,5.2l13.3,7.7L68.9,152.5z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1940"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13650",
  className: "st1",
  d: "M75.5,148.2L75.5,148.2c-0.3-0.2-0.7-0.2-1,0l-6.1,3.5c-0.8,0.5-1.2,1.3-1.3,2.2 c0,0.3,0.1,0.6,0.3,0.8l6.6,3.9l7.9-6.7L75.5,148.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13651",
  className: "st1",
  d: "M81.1,152l-6.1,3.6c-0.7,0.5-1.2,1.3-1.3,2.2c0,0.8,0.6,1.1,1.3,0.7l6.1-3.5 c0.7-0.5,1.2-1.3,1.3-2.2C82.3,151.9,81.8,151.6,81.1,152z"
})))), /*#__PURE__*/React.createElement("path", {
  id: "Path_13652",
  className: "st1",
  d: "M92.6,94.8L92.6,94.8c-0.3-0.2-0.7-0.2-1,0.1l-6.1,3.5c-0.8,0.5-1.2,1.3-1.3,2.2 c0,0.3,0.1,0.6,0.3,0.8l6.6,3.8l7.9-6.7L92.6,94.8z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1962"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1954"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1945"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13653",
  className: "st6",
  d: "M122,143.1L90.3,125c-1.2-0.7-1-1.8,0.3-2.6l18.3-10.6c1.4-0.8,3.1-0.9,4.5-0.2 l31.8,18.1c1.2,0.7,1,1.8-0.3,2.6l-18.3,10.6C125.2,143.7,123.5,143.8,122,143.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13654",
  className: "st2",
  d: "M148,123.7L148,123.7V49.5l-29.5-7.7l-5.4-3.1c-1.6-0.7-3.4-0.6-4.9,0.2l-5.1,2.9H87.4 l4.7,71.6c0,0.6,0.3,1.1,0.8,1.3l29.4,22.2c1.6,0.7,3.4,0.6,4.9-0.2l19.6-11.3C147.5,125.1,148,124.4,148,123.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13655",
  className: "st3",
  d: "M110.8,38.2c-0.9,0-1.8,0.2-2.6,0.7l-5.1,2.9H87.4v74.4c0,0.6,0.3,1.1,0.8,1.3l34.1,19.4 c0.7,0.4,1.5,0.5,2.2,0.5l0.4-74.8L110.8,38.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13656",
  className: "st1",
  d: "M122.7,137c1.3,0.5,2.6,0.5,3.9,0V61.6h-3.9V137z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13657",
  className: "st3",
  d: "M122.4,62.6L88.3,43.1c-1.2-0.7-1.1-2,0.3-2.8L108.2,29c1.5-0.8,3.3-0.9,4.9-0.2 l34.1,19.4c1.2,0.7,1.1,2-0.4,2.8l-19.6,11.3C125.7,63.2,123.9,63.3,122.4,62.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13658",
  className: "st7",
  d: "M146.8,49.6L127.2,61c-1.5,0.8-3.3,0.9-4.9,0.2L88.3,41.7c-0.2-0.1-0.5-0.3-0.6-0.5 c-0.4,0.6-0.2,1.4,0.4,1.8c0,0,0,0,0,0l0.2,0.1l34.1,19.5c1.6,0.7,3.4,0.6,4.9-0.2l19.6-11.3c1.1-0.7,1.5-1.5,1-2.3 C147.6,49.2,147.2,49.4,146.8,49.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1944"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13659",
  className: "st5",
  d: "M123.3,54.7l-22.7-13.2c-0.6-0.3-0.5-0.9,0.2-1.3l9.2-5.3c0.7-0.4,1.5-0.4,2.3-0.1 l22.7,13.2c0.6,0.3,0.5,0.9-0.2,1.3l-9.2,5.3C124.9,55,124,55,123.3,54.7z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1943"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13660",
  className: "st3",
  d: "M111.1,42.1l-1.3-0.8c-0.1,0-0.1-0.1,0-0.2l1.3-0.7c0.1,0,0.2,0,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C111.3,42.2,111.2,42.1,111.1,42.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13661",
  className: "st3",
  d: "M115.5,44.6l-1.3-0.8c-0.1,0-0.1-0.1,0-0.2l1.3-0.7c0.1-0.1,0.2-0.1,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C115.7,44.6,115.6,44.6,115.5,44.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13662",
  className: "st3",
  d: "M119.8,47.1l-1.3-0.8c-0.1,0-0.1-0.1,0-0.2l1.3-0.7c0.1-0.1,0.2-0.1,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C120.1,47.2,119.9,47.2,119.8,47.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13663",
  className: "st3",
  d: "M124.2,49.7l-1.3-0.8c-0.1,0-0.1-0.1,0-0.2l1.3-0.7c0.1,0,0.2,0,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C124.4,49.7,124.3,49.7,124.2,49.7z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_13664",
  className: "st1",
  d: "M100.6,41.5L100.6,41.5l0.1-0.1l9.2-5.3c0.7-0.4,1.5-0.4,2.3-0.1l22.7,13.1 c0.5-0.4,0.6-0.9,0-1.2l-22.6-13.1c-0.7-0.3-1.6-0.3-2.3,0.1l-9.2,5.3C100.1,40.6,100,41.2,100.6,41.5z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1947"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13665",
  className: "st5",
  d: "M131,77.2l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1L131,69.1 c-0.8,0.6-1.3,1.5-1.4,2.5v4.6C129.7,77.2,130.3,77.6,131,77.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13666",
  className: "st4",
  d: "M144.6,61.6c0.2,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.3 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6C145.3,62.1,145,61.7,144.6,61.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1946"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13667",
  className: "st2",
  d: "M134.9,72.2l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6V72C134.6,72.2,134.8,72.3,134.9,72.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13668",
  className: "st4",
  d: "M138.9,69.9l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C138.6,69.9,138.7,70,138.9,69.9z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1949"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13669",
  className: "st5",
  d: "M131,110.6l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1l-12.9,7.4 c-0.8,0.6-1.3,1.5-1.3,2.5v4.6C129.7,110.6,130.3,111,131,110.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13670",
  className: "st4",
  d: "M144.6,94.9c0.2,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.3 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5V96C145.3,95.4,145,95,144.6,94.9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1948"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13671",
  className: "st2",
  d: "M134.9,105.6l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C134.6,105.6,134.8,105.6,134.9,105.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13672",
  className: "st4",
  d: "M138.9,103.3l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C138.6,103.3,138.7,103.4,138.9,103.3z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1951"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13673",
  className: "st5",
  d: "M131,127.2l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1l-12.9,7.4 c-0.8,0.6-1.3,1.5-1.4,2.5v4.6C129.7,127.2,130.3,127.7,131,127.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13674",
  className: "st4",
  d: "M144.6,111.6c0.2,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.4 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6C145.3,112.1,145,111.7,144.6,111.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1950"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13675",
  className: "st2",
  d: "M134.9,122.2l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C134.6,122.2,134.8,122.3,134.9,122.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13676",
  className: "st4",
  d: "M138.9,119.9l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C138.6,119.9,138.7,120,138.9,119.9z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1953"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13677",
  className: "st5",
  d: "M131,93.9l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1L131,85.8 c-0.8,0.6-1.3,1.5-1.4,2.5v4.6C129.7,93.9,130.3,94.3,131,93.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13678",
  className: "st4",
  d: "M144.6,78.3c0.2,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.3 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6C145.3,78.7,145,78.3,144.6,78.3z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1952"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13679",
  className: "st2",
  d: "M134.9,88.9l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C134.6,88.9,134.8,89,134.9,88.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13680",
  className: "st4",
  d: "M138.9,86.6l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-1.2c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C138.6,86.6,138.7,86.7,138.9,86.6z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1955"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13681",
  className: "st1",
  d: "M119.9,72.5L90.1,55.3c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C121.1,72.5,120.5,72.9,119.9,72.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13682",
  className: "st8",
  d: "M119,70.5L91,54.3c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.5,0.3-0.7,0.6-0.5L119,64.6 c0.4,0.3,0.6,0.7,0.6,1.2V70C119.6,70.5,119.4,70.7,119,70.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13683",
  className: "st3",
  d: "M96.8,55.6l-4.2-2.4C92.3,52.9,92,52.5,92,52l0,0c0-0.4,0.3-0.6,0.6-0.5l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C97.4,55.5,97.1,55.7,96.8,55.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13684",
  className: "st5",
  d: "M100.4,56.8c0,0.4-0.3,0.6-0.7,0.4C99.3,56.9,99,56.5,99,56c0-0.4,0.3-0.6,0.7-0.4 C100.1,55.9,100.3,56.3,100.4,56.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13685",
  className: "st5",
  d: "M102.8,58.2c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C102.5,57.3,102.8,57.7,102.8,58.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13686",
  className: "st3",
  d: "M105.2,59.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C104.9,58.7,105.2,59.1,105.2,59.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13687",
  className: "st5",
  d: "M107.6,61c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C107.4,60.1,107.6,60.5,107.6,61z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13688",
  className: "st5",
  d: "M117.8,68.1l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C118.2,68.1,118,68.3,117.8,68.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1956"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13689",
  className: "st1",
  d: "M119.9,82.5L90.1,65.3c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.1 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C121.1,82.5,120.5,82.9,119.9,82.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13690",
  className: "st8",
  d: "M119,80.5L91,64.3c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.5,0.3-0.7,0.6-0.5L119,74.6 c0.4,0.3,0.6,0.7,0.6,1.2V80C119.6,80.5,119.4,80.7,119,80.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13691",
  className: "st3",
  d: "M96.8,65.6l-4.2-2.4C92.3,62.9,92,62.5,92,62l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C97.4,65.6,97.1,65.7,96.8,65.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13692",
  className: "st4",
  d: "M100.4,66.8c0,0.4-0.3,0.6-0.7,0.4C99.3,66.9,99,66.5,99,66c0-0.4,0.3-0.6,0.7-0.4 C100.1,65.9,100.3,66.3,100.4,66.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13693",
  className: "st5",
  d: "M102.8,68.2c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C102.5,67.3,102.8,67.7,102.8,68.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13694",
  className: "st3",
  d: "M105.2,69.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C104.9,68.7,105.2,69.1,105.2,69.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13695",
  className: "st5",
  d: "M107.6,71c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C107.4,70.1,107.6,70.5,107.6,71z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13696",
  className: "st5",
  d: "M117.8,78.1l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C118.2,78.1,118,78.3,117.8,78.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1957"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13697",
  className: "st1",
  d: "M119.9,92.5L90.1,75.3c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.6C121.1,92.5,120.5,92.9,119.9,92.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13698",
  className: "st8",
  d: "M119,90.6L91,74.4c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5L119,84.6 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C119.6,90.5,119.4,90.7,119,90.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13699",
  className: "st3",
  d: "M96.8,75.6l-4.2-2.4C92.3,72.9,92,72.5,92,72l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C97.4,75.6,97.1,75.7,96.8,75.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13700",
  className: "st4",
  d: "M100.4,76.8c0,0.4-0.3,0.6-0.7,0.4C99.3,77,99,76.5,99,76c0-0.4,0.3-0.6,0.7-0.4 C100.1,75.9,100.4,76.3,100.4,76.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13701",
  className: "st5",
  d: "M102.8,78.2c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C102.5,77.3,102.8,77.7,102.8,78.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13702",
  className: "st3",
  d: "M105.2,79.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C104.9,78.7,105.2,79.1,105.2,79.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13703",
  className: "st5",
  d: "M107.6,81c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C107.4,80.1,107.6,80.5,107.6,81z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13704",
  className: "st5",
  d: "M117.8,88.2l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C118.2,88.1,118,88.3,117.8,88.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1958"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13705",
  className: "st1",
  d: "M119.9,102.6L90.1,85.3c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.6C121.1,102.5,120.5,102.9,119.9,102.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13706",
  className: "st8",
  d: "M119,100.6L91,84.4c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5L119,94.6 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C119.6,100.5,119.4,100.7,119,100.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13707",
  className: "st3",
  d: "M96.8,85.6l-4.2-2.4C92.2,82.9,92,82.5,92,82l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C97.4,85.6,97.1,85.8,96.8,85.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13708",
  className: "st5",
  d: "M100.4,86.8c0,0.4-0.3,0.6-0.7,0.4C99.3,87,99,86.5,99,86c0-0.4,0.3-0.6,0.7-0.4 C100.1,85.9,100.3,86.3,100.4,86.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13709",
  className: "st5",
  d: "M102.8,88.2c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C102.5,87.3,102.8,87.7,102.8,88.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13710",
  className: "st3",
  d: "M105.2,89.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C104.9,88.7,105.2,89.1,105.2,89.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13711",
  className: "st5",
  d: "M107.6,91c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C107.4,90.1,107.6,90.5,107.6,91z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13712",
  className: "st3",
  d: "M117.8,98.2l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C118.2,98.2,118,98.3,117.8,98.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1959"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13713",
  className: "st1",
  d: "M119.9,112.6L90.1,95.4c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C121.1,112.5,120.5,112.9,119.9,112.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13714",
  className: "st8",
  d: "M119,110.6L91,94.4c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C119.6,110.6,119.4,110.7,119,110.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13715",
  className: "st3",
  d: "M96.8,95.6l-4.2-2.4C92.2,92.9,92,92.5,92,92l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C97.4,95.6,97.1,95.8,96.8,95.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13716",
  className: "st5",
  d: "M100.4,96.8c0,0.4-0.3,0.6-0.7,0.4C99.3,97,99,96.5,99,96.1c0-0.4,0.3-0.6,0.7-0.4 C100.1,95.9,100.3,96.4,100.4,96.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13717",
  className: "st4",
  d: "M102.8,98.2c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C102.5,97.3,102.8,97.7,102.8,98.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13718",
  className: "st3",
  d: "M105.2,99.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C104.9,98.7,105.2,99.1,105.2,99.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13719",
  className: "st4",
  d: "M107.6,101c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C107.4,100.1,107.6,100.5,107.6,101z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13720",
  className: "st3",
  d: "M117.8,108.2l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C118.2,108.2,118,108.3,117.8,108.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1960"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13721",
  className: "st1",
  d: "M119.9,122.6l-29.8-17.2c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C121.1,122.5,120.5,122.9,119.9,122.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13722",
  className: "st8",
  d: "M119,120.6L91,104.4c-0.4-0.3-0.6-0.7-0.6-1.2V99c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C119.6,120.6,119.4,120.8,119,120.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13723",
  className: "st3",
  d: "M96.8,105.6l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C97.4,105.6,97.1,105.8,96.8,105.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13724",
  className: "st5",
  d: "M100.4,106.8c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C100.1,105.9,100.3,106.4,100.4,106.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13725",
  className: "st5",
  d: "M102.8,108.2c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C102.5,107.3,102.8,107.8,102.8,108.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13726",
  className: "st3",
  d: "M105.2,109.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C104.9,108.7,105.2,109.2,105.2,109.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13727",
  className: "st5",
  d: "M107.6,111c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C107.4,110.1,107.6,110.6,107.6,111z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13728",
  className: "st5",
  d: "M117.8,118.2l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C118.2,118.2,118,118.3,117.8,118.2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1961"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13729",
  className: "st1",
  d: "M119.9,132.6l-29.8-17.2c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C121.1,132.6,120.5,132.9,119.9,132.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13730",
  className: "st8",
  d: "M119,130.6L91,114.4c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C119.6,130.6,119.4,130.8,119,130.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13731",
  className: "st3",
  d: "M96.8,115.6l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C97.4,115.6,97.1,115.8,96.8,115.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13732",
  className: "st4",
  d: "M101.1,117.4c0,0.8-0.6,1.2-1.3,0.8c-0.8-0.5-1.2-1.3-1.3-2.2c0-0.8,0.6-1.2,1.3-0.7 C100.6,115.6,101.1,116.5,101.1,117.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13733",
  className: "st5",
  d: "M106.2,120.3c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C105.9,119.4,106.1,119.8,106.2,120.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13734",
  className: "st3",
  d: "M108.6,121.7c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C108.3,120.8,108.5,121.2,108.6,121.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13735",
  className: "st5",
  d: "M111,123.1c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C110.7,122.2,111,122.6,111,123.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13736",
  className: "st3",
  d: "M117.8,128.2l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C118.2,128.2,118,128.3,117.8,128.2z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1982"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1974"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1965"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13737",
  className: "st6",
  d: "M169.9,170.6l-31.8-18.1c-1.2-0.7-1-1.8,0.3-2.6l18.3-10.6c1.4-0.8,3.1-0.9,4.5-0.2 l31.8,18.1c1.2,0.7,1,1.8-0.3,2.6l-18.3,10.6C173.1,171.2,171.4,171.3,169.9,170.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13738",
  className: "st2",
  d: "M195.9,151.2L195.9,151.2V77l-29.5-7.7l-5.4-3.1c-1.6-0.7-3.4-0.6-4.9,0.2l-5.1,2.9 h-15.7l4.7,71.6c0,0.6,0.3,1.1,0.8,1.3l29.4,22.2c1.6,0.7,3.4,0.6,4.9-0.2l19.6-11.3C195.4,152.6,195.9,151.9,195.9,151.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13739",
  className: "st3",
  d: "M158.7,65.7c-0.9,0-1.8,0.2-2.6,0.7l-5.1,2.9h-15.7v74.4c0,0.6,0.3,1.1,0.8,1.3 l34.1,19.4c0.7,0.4,1.5,0.5,2.2,0.5l0.4-74.8L158.7,65.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13740",
  className: "st1",
  d: "M170.6,164.6c1.3,0.5,2.6,0.5,3.9,0V89.2h-3.9V164.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13741",
  className: "st3",
  d: "M170.2,90l-34.1-19.5c-1.2-0.7-1.1-2,0.4-2.8l19.6-11.3c1.5-0.8,3.3-0.9,4.9-0.2 l34.1,19.4c1.2,0.7,1.1,2-0.4,2.8l-19.6,11.3C173.6,90.7,171.8,90.7,170.2,90z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13742",
  className: "st7",
  d: "M194.7,77.1l-19.6,11.3c-1.5,0.8-3.3,0.9-4.9,0.2l-34.1-19.4c-0.2-0.1-0.5-0.3-0.6-0.6 c-0.4,0.6-0.2,1.4,0.4,1.8c0,0,0,0,0,0c0.1,0,0.2,0.1,0.2,0.1L170.2,90c1.6,0.7,3.4,0.6,4.9-0.2l19.6-11.3 c1.1-0.7,1.5-1.6,1-2.3C195.4,76.6,195.1,76.9,194.7,77.1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1964"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13743",
  className: "st5",
  d: "M171.2,82.2L148.5,69c-0.6-0.3-0.5-0.9,0.2-1.3l9.2-5.3c0.7-0.4,1.5-0.4,2.3-0.1 l22.7,13.2c0.6,0.3,0.5,0.9-0.2,1.3l-9.2,5.3C172.8,82.5,171.9,82.5,171.2,82.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1963"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13744",
  className: "st3",
  d: "M159,69.6l-1.3-0.7c-0.1-0.1-0.1-0.1,0-0.2l1.3-0.7c0.1,0,0.2,0,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C159.2,69.7,159.1,69.7,159,69.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13745",
  className: "st3",
  d: "M163.4,72.1l-1.3-0.8c-0.1-0.1-0.1-0.1,0-0.2l1.3-0.7c0.1-0.1,0.2-0.1,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C163.6,72.2,163.5,72.2,163.4,72.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13746",
  className: "st3",
  d: "M167.7,74.7l-1.3-0.8c-0.1,0-0.1-0.1,0-0.2l1.3-0.7c0.1-0.1,0.2-0.1,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C168,74.7,167.8,74.7,167.7,74.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13747",
  className: "st3",
  d: "M172.1,77.2l-1.3-0.8c-0.1,0-0.1-0.1,0-0.2l1.3-0.7c0.1,0,0.2,0,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C172.4,77.2,172.2,77.2,172.1,77.2z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_13748",
  className: "st1",
  d: "M148.5,69L148.5,69l0.1-0.1l9.2-5.3c0.7-0.4,1.5-0.4,2.3-0.1l22.7,13.1 c0.5-0.4,0.6-0.9,0-1.2l-22.7-13.1c-0.7-0.3-1.6-0.3-2.3,0.1l-9.2,5.3C148,68.1,147.9,68.7,148.5,69z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1967"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13749",
  className: "st5",
  d: "M178.9,104.7l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1l-12.9,7.4 c-0.8,0.6-1.3,1.5-1.3,2.5v4.6C177.6,104.7,178.2,105.2,178.9,104.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13750",
  className: "st4",
  d: "M192.5,89.1c0.2,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.4 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6C193.1,89.6,192.9,89.2,192.5,89.1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1966"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13751",
  className: "st2",
  d: "M182.8,99.7L184,99c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C182.5,99.7,182.7,99.8,182.8,99.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13752",
  className: "st4",
  d: "M186.8,97.4l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C186.5,97.4,186.6,97.6,186.8,97.4z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1969"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13753",
  className: "st5",
  d: "M178.9,138.1l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1l-12.9,7.4 c-0.8,0.6-1.3,1.5-1.3,2.5v4.6C177.6,138.1,178.2,138.5,178.9,138.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13754",
  className: "st4",
  d: "M192.5,122.4c0.2,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.4 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6C193.1,122.9,192.9,122.5,192.5,122.4z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1968"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13755",
  className: "st2",
  d: "M182.8,133.1l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.2c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C182.5,133.1,182.7,133.2,182.8,133.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13756",
  className: "st4",
  d: "M186.8,130.8l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C186.5,130.8,186.6,130.9,186.8,130.8z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1971"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13757",
  className: "st5",
  d: "M178.9,154.7l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1l-12.9,7.3 c-0.8,0.6-1.3,1.5-1.3,2.5v4.6C177.6,154.7,178.2,155.2,178.9,154.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13758",
  className: "st4",
  d: "M192.5,139.1c0.2,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.4 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6C193.1,139.6,192.9,139.2,192.5,139.1z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1970"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13759",
  className: "st2",
  d: "M182.8,149.7l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C182.5,149.7,182.7,149.8,182.8,149.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13760",
  className: "st4",
  d: "M186.8,147.4l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6V145c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C186.5,147.4,186.6,147.6,186.8,147.4z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1973"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13761",
  className: "st5",
  d: "M178.9,121.4l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1l-12.9,7.4 c-0.8,0.6-1.3,1.5-1.3,2.5v4.6C177.6,121.4,178.2,121.8,178.9,121.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13762",
  className: "st4",
  d: "M192.5,105.8c0.2,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.4 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6C193.1,106.2,192.9,105.8,192.5,105.8z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1972"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13763",
  className: "st2",
  d: "M182.8,116.4l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C182.5,116.4,182.7,116.5,182.8,116.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13764",
  className: "st4",
  d: "M186.8,114.1l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C186.5,114.1,186.6,114.2,186.8,114.1z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1975"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13765",
  className: "st1",
  d: "M167.8,100L138,82.8c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C169,100,168.4,100.4,167.8,100z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13766",
  className: "st8",
  d: "M166.9,98l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C167.5,98,167.2,98.2,166.9,98z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13767",
  className: "st3",
  d: "M144.7,83l-4.2-2.5c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.5 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C145.3,83,145,83.2,144.7,83z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13768",
  className: "st5",
  d: "M148.3,84.3c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C148,83.4,148.2,83.8,148.3,84.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13769",
  className: "st5",
  d: "M150.7,85.7c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C150.4,84.8,150.7,85.2,150.7,85.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13770",
  className: "st3",
  d: "M153.1,87.1c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C152.8,86.2,153.1,86.6,153.1,87.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13771",
  className: "st5",
  d: "M155.5,88.5c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C155.2,87.6,155.5,88,155.5,88.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13772",
  className: "st5",
  d: "M165.7,95.6l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C166.1,95.6,165.9,95.8,165.7,95.6z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1976"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13773",
  className: "st1",
  d: "M167.8,110L138,92.8c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C169,110,168.4,110.4,167.8,110z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13774",
  className: "st8",
  d: "M166.9,108l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C167.5,108,167.2,108.2,166.9,108z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13775",
  className: "st3",
  d: "M144.7,93.1l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C145.3,93,145,93.2,144.7,93.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13776",
  className: "st4",
  d: "M148.3,94.3c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C148,93.4,148.2,93.8,148.3,94.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13777",
  className: "st5",
  d: "M150.7,95.7c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C150.4,94.8,150.7,95.2,150.7,95.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13778",
  className: "st3",
  d: "M153.1,97.1c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C152.8,96.2,153.1,96.6,153.1,97.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13779",
  className: "st5",
  d: "M155.5,98.5c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C155.2,97.6,155.5,98,155.5,98.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13780",
  className: "st5",
  d: "M165.7,105.7l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C166.1,105.6,165.9,105.8,165.7,105.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1977"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13781",
  className: "st1",
  d: "M167.8,120L138,102.8c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C169,120,168.4,120.4,167.8,120z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13782",
  className: "st8",
  d: "M166.9,118l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C167.5,118,167.2,118.2,166.9,118z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13783",
  className: "st3",
  d: "M144.7,103.1l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C145.3,103.1,145,103.3,144.7,103.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13784",
  className: "st4",
  d: "M148.3,104.3c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C148,103.4,148.2,103.8,148.3,104.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13785",
  className: "st5",
  d: "M150.7,105.7c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C150.4,104.8,150.7,105.2,150.7,105.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13786",
  className: "st3",
  d: "M153.1,107.1c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C152.8,106.2,153.1,106.6,153.1,107.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13787",
  className: "st5",
  d: "M155.5,108.5c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C155.3,107.6,155.5,108,155.5,108.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13788",
  className: "st5",
  d: "M165.7,115.7l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C166.1,115.7,165.9,115.8,165.7,115.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1978"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13789",
  className: "st1",
  d: "M167.8,130L138,112.9c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C169,130,168.4,130.4,167.8,130z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13790",
  className: "st8",
  d: "M166.9,128.1l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C167.5,128,167.2,128.2,166.9,128.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13791",
  className: "st3",
  d: "M144.7,113.1l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C145.3,113.1,145,113.3,144.7,113.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13792",
  className: "st5",
  d: "M148.3,114.3c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C148,113.4,148.2,113.8,148.3,114.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13793",
  className: "st5",
  d: "M150.7,115.7c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C150.4,114.8,150.7,115.2,150.7,115.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13794",
  className: "st3",
  d: "M153.1,117.1c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C152.8,116.2,153.1,116.6,153.1,117.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13795",
  className: "st5",
  d: "M155.5,118.5c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C155.2,117.6,155.5,118,155.5,118.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13796",
  className: "st3",
  d: "M165.7,125.7l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C166.1,125.7,165.9,125.8,165.7,125.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1979"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13797",
  className: "st1",
  d: "M167.8,140L138,122.9c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C169,140,168.4,140.4,167.8,140z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13798",
  className: "st8",
  d: "M166.9,138.1l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C167.5,138,167.2,138.3,166.9,138.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13799",
  className: "st3",
  d: "M144.7,123.1l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C145.3,123.1,145,123.3,144.7,123.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13800",
  className: "st5",
  d: "M148.3,124.3c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C148,123.4,148.2,123.9,148.3,124.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13801",
  className: "st4",
  d: "M150.7,125.7c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C150.4,124.8,150.7,125.3,150.7,125.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13802",
  className: "st3",
  d: "M153.1,127.1c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C152.8,126.2,153.1,126.7,153.1,127.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13803",
  className: "st4",
  d: "M155.5,128.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C155.2,127.7,155.5,128.1,155.5,128.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13804",
  className: "st3",
  d: "M165.7,135.7l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C166.1,135.7,165.9,135.8,165.7,135.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1980"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13805",
  className: "st1",
  d: "M167.8,150.1L138,132.9c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C169,150,168.4,150.4,167.8,150.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13806",
  className: "st8",
  d: "M166.9,148.1l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.2C167.5,148.1,167.2,148.3,166.9,148.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13807",
  className: "st3",
  d: "M144.7,133.1l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C145.3,133.1,145,133.3,144.7,133.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13808",
  className: "st5",
  d: "M148.3,134.4c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C148,133.4,148.2,133.9,148.3,134.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13809",
  className: "st5",
  d: "M150.7,135.8c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C150.4,134.8,150.7,135.3,150.7,135.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13810",
  className: "st3",
  d: "M153.1,137.2c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C152.8,136.2,153.1,136.7,153.1,137.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13811",
  className: "st5",
  d: "M155.5,138.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C155.2,137.7,155.5,138.1,155.5,138.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13812",
  className: "st5",
  d: "M165.7,145.7l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C166.1,145.7,165.9,145.8,165.7,145.7z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1981"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13813",
  className: "st1",
  d: "M167.8,160.1L138,142.9c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C169,160,168.4,160.4,167.8,160.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13814",
  className: "st8",
  d: "M166.9,158.1l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.2C167.5,158.1,167.2,158.3,166.9,158.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13815",
  className: "st3",
  d: "M144.7,143.1l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C145.3,143.1,145,143.3,144.7,143.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13816",
  className: "st4",
  d: "M149,144.9c0,0.8-0.6,1.2-1.3,0.8c-0.8-0.5-1.3-1.3-1.3-2.2c0-0.8,0.6-1.2,1.3-0.8 C148.5,143.2,149,144,149,144.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13817",
  className: "st5",
  d: "M154,147.8c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C153.8,146.9,154,147.3,154,147.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13818",
  className: "st3",
  d: "M156.5,149.2c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C156.2,148.3,156.4,148.7,156.5,149.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13819",
  className: "st5",
  d: "M158.9,150.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C158.6,149.7,158.9,150.1,158.9,150.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13820",
  className: "st3",
  d: "M165.7,155.7l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C166.1,155.7,165.9,155.8,165.7,155.7z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1985"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1983"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13821",
  className: "st3",
  d: "M201.9,72.1l-1.2-0.7v-1.8c-0.1-2.2-1.3-4.2-3.1-5.4l-9.8-5.5c-1.7-1-3.1-0.2-3.1,1.8 v19.9l-1.3-18.8v-1.9c0-2.8,2-3.9,4.4-2.5l9.7,5.6c2.6,1.7,4.2,4.5,4.4,7.6V72.1z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_13822",
  className: "st3",
  d: "M197.6,74.6l4.4-2.5l-0.9-3.1l-1.2-3.1c0,0-2.1-2.3-2.3-2.4s-5.9-3.3-5.9-3.3l-4.8-3.5 l-2.3,0.1l-4.2,2.4l3,1.3c0,0,1.7,0.8,2.1,1c0.8,0.5,1.5,1.1,2.1,1.7l2.1,0.8l0.4-0.1l3.8,2.5l1.2,0.5l0.6,1l1,2.8L197.6,74.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13823",
  className: "st2",
  d: "M184.7,80.2l-4.4,2.5c0,0-0.3-20.9-0.3-20.9s1-1.4,1-1.4l2.4-0.5l1.9,1.4l-0.6-0.2 l-0.3,0.2l0.3,0.5L184.7,80.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1984"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13824",
  className: "st1",
  d: "M197.6,74.6l-1.3-0.8V72c-0.1-2.2-1.3-4.2-3.1-5.4l-9.7-5.6c-1.7-1-3.1-0.2-3.1,1.8v19.9 l-1.3-0.7V62.1c0-2.8,2-3.9,4.4-2.5l9.7,5.6c2.6,1.7,4.2,4.5,4.4,7.6V74.6z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2005"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1997"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1988"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13825",
  className: "st6",
  d: "M216.5,192.9l-22.3-12.7c-0.8-0.5-0.7-1.3,0.2-1.8l12.8-7.4c1-0.5,2.2-0.6,3.2-0.1 l22.3,12.7c0.8,0.5,0.7,1.3-0.2,1.8l-12.8,7.3C218.7,193.3,217.6,193.4,216.5,192.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13826",
  className: "st2",
  d: "M243.8,160.6L243.8,160.6V86.4l-29.5-7.7l-5.4-3.1c-1.6-0.7-3.4-0.6-4.9,0.2l-5.1,2.9 h-15.7l4.7,71.6c0,0.5,0.3,1,0.8,1.3l29.4,22.2c1.6,0.7,3.4,0.6,4.9-0.2l19.6-11.3C243.3,162,243.7,161.3,243.8,160.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13827",
  className: "st3",
  d: "M206.6,75.1c-0.9,0-1.8,0.2-2.6,0.7l-5.1,2.9h-15.7v74.4c0,0.6,0.3,1.1,0.8,1.3 l34.1,19.4c0.7,0.4,1.5,0.5,2.3,0.5l0.4-74.8L206.6,75.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13828",
  className: "st1",
  d: "M218.4,174c1.3,0.5,2.6,0.4,3.9-0.1V98.6h-3.9V174z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13829",
  className: "st3",
  d: "M218.1,99.5L184.1,80c-1.2-0.7-1.1-2,0.4-2.8L204,65.9c1.5-0.8,3.3-0.9,4.9-0.2L243,85.1 c1.2,0.7,1.1,2-0.4,2.8L223,99.3C221.5,100.1,219.7,100.2,218.1,99.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13830",
  className: "st7",
  d: "M242.6,86.6L223,97.9c-1.5,0.8-3.3,0.9-4.9,0.2l-34.1-19.4c-0.2-0.1-0.5-0.3-0.6-0.6 c-0.4,0.6-0.2,1.4,0.4,1.8c0,0,0,0,0,0l0.2,0.1l34.1,19.4c1.6,0.7,3.4,0.6,4.9-0.2l19.6-11.3c1.1-0.7,1.5-1.6,1-2.3 C243.4,86.1,243,86.4,242.6,86.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1987"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13831",
  className: "st5",
  d: "M219.1,91.6l-22.7-13.2c-0.6-0.3-0.5-0.9,0.2-1.3l9.2-5.3c0.7-0.4,1.5-0.4,2.3-0.1 l22.7,13.2c0.6,0.3,0.5,0.9-0.2,1.3l-9.2,5.3C220.7,91.9,219.8,91.9,219.1,91.6z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1986"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13832",
  className: "st3",
  d: "M206.8,79l-1.3-0.8c-0.1,0-0.1-0.1,0-0.2l1.3-0.7c0.1-0.1,0.2-0.1,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C207.1,79.1,206.9,79.1,206.8,79z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13833",
  className: "st3",
  d: "M211.2,81.6l-1.3-0.8c-0.1,0-0.1-0.1,0-0.2l1.3-0.7c0.1,0,0.2,0,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C211.5,81.6,211.3,81.6,211.2,81.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13834",
  className: "st3",
  d: "M215.6,84.1l-1.3-0.8c-0.1,0-0.1-0.1,0-0.2l1.3-0.7c0.1,0,0.2,0,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C215.8,84.1,215.7,84.1,215.6,84.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13835",
  className: "st3",
  d: "M220,86.6l-1.3-0.8c-0.1,0-0.1-0.1,0-0.2l1.3-0.7c0.1-0.1,0.2-0.1,0.3,0l1.3,0.8 c0.1,0,0.1,0.1,0,0.2l-1.3,0.7C220.2,86.6,220.1,86.6,220,86.6z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_13836",
  className: "st1",
  d: "M196.4,78.4L196.4,78.4l0.1-0.1l9.2-5.3c0.7-0.4,1.5-0.4,2.3-0.1l22.7,13.2 c0.5-0.4,0.6-0.9,0-1.2L208,71.7c-0.7-0.3-1.6-0.3-2.3,0.1l-9.2,5.3C195.9,77.5,195.8,78.1,196.4,78.4z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1990"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13837",
  className: "st5",
  d: "M226.8,114.1l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1l-12.9,7.4 c-0.8,0.6-1.3,1.5-1.3,2.5v4.6C225.5,114.1,226.1,114.6,226.8,114.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13838",
  className: "st4",
  d: "M240.4,98.5c0.3,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.4 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6C241,99,240.8,98.6,240.4,98.5z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1989"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13839",
  className: "st2",
  d: "M230.7,109.1l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.5v1.3C230.4,109.1,230.5,109.2,230.7,109.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13840",
  className: "st4",
  d: "M234.7,106.9l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C234.4,106.8,234.5,106.9,234.7,106.9z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1992"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13841",
  className: "st5",
  d: "M226.8,147.5l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5V133c0-1-0.6-1.4-1.3-1l-12.9,7.4 c-0.8,0.6-1.3,1.5-1.3,2.5v4.6C225.5,147.5,226.1,147.9,226.8,147.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13842",
  className: "st4",
  d: "M240.4,131.8c0.3,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.4 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5V133C241,132.3,240.8,131.9,240.4,131.8z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1991"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13843",
  className: "st2",
  d: "M230.7,142.5l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6V140c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C230.4,142.5,230.5,142.6,230.7,142.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13844",
  className: "st4",
  d: "M234.7,140.2l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C234.4,140.2,234.5,140.3,234.7,140.2z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1994"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13845",
  className: "st5",
  d: "M226.8,164.2l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1l-12.9,7.4 c-0.8,0.6-1.3,1.5-1.3,2.5v4.6C225.5,164.1,226.1,164.6,226.8,164.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13846",
  className: "st4",
  d: "M240.4,148.5c0.3,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.4 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6C241,149,240.8,148.6,240.4,148.5z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1993"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13847",
  className: "st2",
  d: "M230.7,159.1l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C230.4,159.1,230.5,159.2,230.7,159.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13848",
  className: "st4",
  d: "M234.7,156.9l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C234.4,156.9,234.5,157,234.7,156.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13849",
  className: "st4",
  d: "M233.8,165.4l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.6v1.3C233.5,165.4,233.6,165.5,233.8,165.4z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1996"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13850",
  className: "st5",
  d: "M226.8,130.8l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6c0-1-0.6-1.4-1.3-1l-12.9,7.4 c-0.8,0.6-1.3,1.5-1.3,2.5v4.6C225.5,130.8,226.1,131.2,226.8,130.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13851",
  className: "st4",
  d: "M240.4,115.2c0.3,0.3,0.4,0.6,0.3,1v4.6c0,1-0.5,1.9-1.3,2.5l-12.9,7.4 c-0.2,0.1-0.4,0.2-0.6,0.1c0.3,0.2,0.7,0.2,1,0l12.9-7.4c0.8-0.6,1.3-1.5,1.3-2.5v-4.6C241,115.7,240.8,115.2,240.4,115.2z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1995"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13852",
  className: "st2",
  d: "M230.7,125.8l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6v-1.3c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.5v1.3C230.4,125.8,230.5,125.9,230.7,125.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13853",
  className: "st4",
  d: "M234.7,123.5l1.2-0.7c0.2-0.1,0.3-0.3,0.3-0.6V121c0-0.2-0.1-0.3-0.3-0.2l-1.2,0.7 c-0.2,0.1-0.3,0.3-0.3,0.5v1.3C234.4,123.5,234.5,123.6,234.7,123.5z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1998"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13854",
  className: "st1",
  d: "M215.7,109.4l-29.8-17.2c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C216.9,109.4,216.3,109.8,215.7,109.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13855",
  className: "st8",
  d: "M214.8,107.4l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C215.4,107.4,215.1,107.6,214.8,107.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13856",
  className: "st3",
  d: "M192.6,92.5l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C193.2,92.4,192.9,92.6,192.6,92.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13857",
  className: "st5",
  d: "M196.2,93.7c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C195.9,92.8,196.1,93.2,196.2,93.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13858",
  className: "st5",
  d: "M198.6,95.1c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C198.3,94.2,198.6,94.6,198.6,95.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13859",
  className: "st3",
  d: "M201,96.5c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C200.7,95.6,201,96,201,96.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13860",
  className: "st5",
  d: "M203.4,97.9c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C203.1,97,203.4,97.4,203.4,97.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13861",
  className: "st5",
  d: "M213.6,105.1l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7V102c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C214,105.1,213.8,105.2,213.6,105.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1999"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13862",
  className: "st1",
  d: "M215.7,119.4l-29.8-17.2c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C216.9,119.4,216.3,119.8,215.7,119.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13863",
  className: "st8",
  d: "M214.8,117.4l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C215.4,117.4,215.1,117.6,214.8,117.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13864",
  className: "st3",
  d: "M192.6,102.5l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C193.2,102.5,192.9,102.7,192.6,102.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13865",
  className: "st4",
  d: "M196.2,103.7c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C195.9,102.8,196.1,103.3,196.2,103.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13866",
  className: "st5",
  d: "M198.6,105.1c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C198.3,104.2,198.6,104.6,198.6,105.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13867",
  className: "st3",
  d: "M201,106.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C200.7,105.7,201,106.1,201,106.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13868",
  className: "st5",
  d: "M203.4,107.9c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C203.1,107,203.4,107.4,203.4,107.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13869",
  className: "st5",
  d: "M213.6,115.1l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7V112c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C214,115.1,213.8,115.2,213.6,115.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2000"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13870",
  className: "st1",
  d: "M215.7,129.4l-29.8-17.2c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C216.9,129.4,216.3,129.8,215.7,129.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13871",
  className: "st8",
  d: "M214.8,127.5l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C215.4,127.4,215.1,127.6,214.8,127.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13872",
  className: "st3",
  d: "M192.6,112.5l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C193.2,112.5,192.9,112.7,192.6,112.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13873",
  className: "st4",
  d: "M196.2,113.7c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C195.9,112.8,196.1,113.3,196.2,113.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13874",
  className: "st5",
  d: "M198.6,115.1c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C198.3,114.2,198.6,114.7,198.6,115.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13875",
  className: "st3",
  d: "M201,116.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C200.7,115.7,201,116.1,201,116.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13876",
  className: "st5",
  d: "M203.4,117.9c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C203.1,117,203.4,117.4,203.4,117.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13877",
  className: "st5",
  d: "M213.6,125.1l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7V122c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C214,125.1,213.8,125.2,213.6,125.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2001"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13878",
  className: "st1",
  d: "M215.7,139.5l-29.8-17.2c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C216.9,139.4,216.3,139.8,215.7,139.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13879",
  className: "st8",
  d: "M214.8,137.5l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C215.4,137.5,215.1,137.7,214.8,137.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13880",
  className: "st3",
  d: "M192.6,122.5l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C193.2,122.5,192.9,122.7,192.6,122.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13881",
  className: "st5",
  d: "M196.2,123.7c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C195.9,122.8,196.1,123.3,196.2,123.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13882",
  className: "st5",
  d: "M198.6,125.1c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C198.3,124.2,198.5,124.7,198.6,125.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13883",
  className: "st3",
  d: "M201,126.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C200.7,125.7,201,126.1,201,126.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13884",
  className: "st5",
  d: "M203.4,127.9c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C203.1,127,203.4,127.5,203.4,127.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13885",
  className: "st3",
  d: "M213.6,135.1l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C214,135.1,213.8,135.2,213.6,135.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2002"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13886",
  className: "st1",
  d: "M215.7,149.5l-29.8-17.2c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C216.9,149.4,216.3,149.8,215.7,149.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13887",
  className: "st8",
  d: "M214.8,147.5l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.6,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C215.4,147.5,215.1,147.7,214.8,147.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13888",
  className: "st3",
  d: "M192.6,132.5l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C193.2,132.5,192.9,132.7,192.6,132.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13889",
  className: "st5",
  d: "M196.2,133.8c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C195.9,132.8,196.1,133.3,196.2,133.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13890",
  className: "st4",
  d: "M198.6,135.2c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C198.3,134.2,198.6,134.7,198.6,135.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13891",
  className: "st3",
  d: "M201,136.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C200.7,135.7,201,136.1,201,136.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13892",
  className: "st4",
  d: "M203.4,138c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C203.1,137,203.4,137.5,203.4,138z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13893",
  className: "st3",
  d: "M213.6,145.1l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C214,145.1,213.8,145.2,213.6,145.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2003"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13894",
  className: "st1",
  d: "M215.7,159.5l-29.8-17.2c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C216.9,159.4,216.3,159.9,215.7,159.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13895",
  className: "st8",
  d: "M214.8,157.5l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C215.4,157.5,215.1,157.7,214.8,157.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13896",
  className: "st3",
  d: "M192.6,142.5l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C193.2,142.5,192.9,142.7,192.6,142.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13897",
  className: "st5",
  d: "M196.2,143.8c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C195.9,142.8,196.1,143.3,196.2,143.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13898",
  className: "st5",
  d: "M198.6,145.2c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C198.3,144.2,198.5,144.7,198.6,145.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13899",
  className: "st3",
  d: "M201,146.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C200.7,145.7,201,146.1,201,146.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13900",
  className: "st5",
  d: "M203.4,148c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C203.1,147,203.4,147.5,203.4,148z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13901",
  className: "st5",
  d: "M213.6,155.1l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C214,155.1,213.8,155.2,213.6,155.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2004"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13902",
  className: "st1",
  d: "M215.7,169.5l-29.8-17.2c-0.7-0.5-1.2-1.4-1.2-2.3v-5.7c0-0.9,0.5-1.3,1.2-0.9l29.8,17.2 c0.7,0.5,1.2,1.4,1.2,2.3v5.7C216.9,169.5,216.3,169.9,215.7,169.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13903",
  className: "st8",
  d: "M214.8,167.5l-28.1-16.2c-0.4-0.3-0.6-0.7-0.6-1.2v-4.3c0-0.4,0.3-0.7,0.6-0.5l28.1,16.2 c0.4,0.3,0.6,0.7,0.6,1.2v4.3C215.4,167.5,215.1,167.7,214.8,167.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13904",
  className: "st3",
  d: "M192.6,152.5l-4.2-2.4c-0.4-0.3-0.6-0.7-0.6-1.1l0,0c0-0.4,0.3-0.6,0.6-0.4l4.2,2.4 c0.4,0.3,0.6,0.7,0.6,1.1l0,0C193.2,152.5,192.9,152.7,192.6,152.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13905",
  className: "st4",
  d: "M196.9,154.3c0,0.8-0.6,1.2-1.3,0.8c-0.8-0.5-1.3-1.3-1.3-2.2c0-0.8,0.6-1.2,1.3-0.8 C196.4,152.6,196.9,153.4,196.9,154.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13906",
  className: "st5",
  d: "M201.9,157.3c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C201.7,156.3,201.9,156.8,201.9,157.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13907",
  className: "st3",
  d: "M204.4,158.6c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C204.1,157.7,204.3,158.2,204.4,158.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13908",
  className: "st5",
  d: "M206.8,160c0,0.4-0.3,0.6-0.7,0.4c-0.4-0.3-0.7-0.7-0.7-1.2c0-0.4,0.3-0.6,0.7-0.4 C206.5,159.1,206.7,159.6,206.8,160z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13909",
  className: "st3",
  d: "M213.6,165.1l-1.4-0.8c-0.2-0.2-0.4-0.4-0.4-0.7v-1.5c0-0.3,0.2-0.4,0.4-0.3l1.4,0.8 c0.2,0.2,0.4,0.4,0.4,0.7v1.5C214,165.1,213.8,165.2,213.6,165.1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2009"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13910",
  className: "st6",
  d: "M113.2,222.3L46.8,184c-1.9-1.1-1.7-3,0.5-4.2l45.2-26.1c2.3-1.3,5-1.4,7.3-0.3l66.3,38.3 c1.9,1.1,1.6,3-0.5,4.2l-45.2,26.1C118.2,223.2,115.5,223.3,113.2,222.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13911",
  className: "st5",
  d: "M181.7,123.8l-66.3-38.3c-0.7-0.4-1.5-0.5-2.2-0.3l0,0l-0.1,0.1l0,0l-2.4,0.9l2.2,1v0.1 l-10.8,49.3c-0.5,2.5,0.5,5.3,2.4,6.4l64.7,37.4l-0.2,2.8l2.6-1c1-0.5,1.7-1.5,1.9-2.7l10.8-49.2 C184.7,127.8,183.6,124.9,181.7,123.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13912",
  className: "st2",
  d: "M181.7,123.8l-66.3-38.3c-0.7-0.4-1.5-0.5-2.2-0.3l0,0l-0.1,0.1l0,0l-2.4,0.9l2.2,1v0.1 l-7.1,32.4l32.5,25.3l45.8-18.6C183.4,125.3,182.7,124.4,181.7,123.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13913",
  className: "st9",
  d: "M179.2,131.4l5.1-2.1c0.1-1.9-0.6-3.8-2.1-5.1l-8,3.4L179.2,131.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13914",
  className: "st3",
  d: "M166.5,182.8l-66.3-38.2c-1.9-1.1-3-4-2.4-6.4L108.6,89c0.5-2.5,2.5-3.6,4.4-2.5l66.3,38.3 c1.9,1.1,3,4,2.4,6.4l-10.8,49.2C170.4,182.8,168.4,183.9,166.5,182.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13915",
  className: "st4",
  d: "M179.9,124.5l-66.3-38.3c-0.8-0.5-1.8-0.5-2.6-0.1c0.7-0.1,1.4,0,2,0.3l66.3,38.3 c1.9,1.1,3,3.9,2.4,6.4l-10.8,49.2c-0.2,1.1-0.8,2-1.8,2.6c1.3-0.4,2.2-1.5,2.4-2.8l10.8-49.2 C182.9,128.5,181.8,125.6,179.9,124.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13916",
  className: "st4",
  d: "M165.1,179.2l-62.4-36c-1.7-1-2.7-3.6-2.2-5.9l9.9-45c0.5-2.2,2.3-3.3,4-2.3l62.4,36 c1.8,1.3,2.7,3.6,2.2,5.9l-9.9,45C168.6,179.1,166.8,180.2,165.1,179.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13917",
  className: "st5",
  d: "M165.1,179.2l-62.4-36c-1.7-1-2.7-3.6-2.2-5.9l9.9-45c0.5-2.2,2.3-3.3,4-2.3l62.4,36 c1.8,1.3,2.7,3.6,2.2,5.9l-9.9,45C168.6,179.1,166.8,180.2,165.1,179.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13918",
  className: "st1",
  d: "M165.7,179l-62.4-36c-1.7-1-2.7-3.6-2.2-5.9l9.9-45c0.2-1,0.7-1.8,1.6-2.4 c-1.1,0.4-2,1.4-2.1,2.6l-9.9,45c-0.5,2.2,0.4,4.5,2.2,5.9l62.4,36c0.7,0.5,1.7,0.5,2.4,0.1C166.9,179.4,166.3,179.3,165.7,179z "
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13919",
  className: "st5",
  d: "M167.5,184.5l-9.1-1.2l-58.5-33.8c-2.4-1.1-5.1-0.9-7.3,0.3L51,173.7l-5.5-0.7v3.1l0,0 c0,0.8,0.5,1.6,1.3,1.9l66.3,38.3c2.4,1.1,5.1,1,7.3-0.3l45.2-26.1c1-0.4,1.7-1.4,1.8-2.5l0,0L167.5,184.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13920",
  className: "st2",
  d: "M123.5,163.1l-4.2-2.4H73.6l-22.5,13l-5.5-0.7v3.1l0,0c0,0.8,0.5,1.6,1.2,1.9l66.3,38.3 c1.2,0.6,2.5,0.8,3.8,0.7L123.5,163.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13921",
  className: "st1",
  d: "M48,173.3l-2.4-0.3v3.1l0,0c0,0.8,0.5,1.6,1.2,1.9l1.2,0.7L48,173.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13922",
  className: "st9",
  d: "M113.8,216.7c2,0.7,4.3,0.5,6.2-0.4v-6.9h-6.2V216.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13923",
  className: "st3",
  d: "M113.2,213.3L46.8,175c-1.9-1.1-1.7-3,0.5-4.2l45.2-26.1c2.3-1.3,5-1.4,7.3-0.3l66.3,38.3 c1.9,1.1,1.6,3-0.5,4.2L120.5,213C118.2,214.2,115.5,214.3,113.2,213.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13924",
  className: "st4",
  d: "M165.7,185.7l-45.2,26.1c-2.3,1.2-5,1.4-7.3,0.3l-66.3-38.3c-0.5-0.3-0.9-0.7-1.1-1.2 c-0.3,1,0.2,2,1.2,2.4l66.3,38.3c2.3,1.1,5.1,1,7.3-0.3l45.2-26.1c1.5-0.8,2-2,1.7-2.9C167.1,184.7,166.5,185.4,165.7,185.7z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2006"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13925",
  className: "st1",
  d: "M75,162.3l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3.5-2c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3.5,2.1C75.7,162.5,75.3,162.4,75,162.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13926",
  className: "st1",
  d: "M79.7,164.9l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3.6-2c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3.5,2C80.3,165.1,80,165.1,79.7,164.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13927",
  className: "st1",
  d: "M84.3,167.6l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3.5-2c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3.6,2C85,167.7,84.6,167.7,84.3,167.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13928",
  className: "st1",
  d: "M90.7,165.4l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C91.3,165.6,91,165.6,90.7,165.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13929",
  className: "st1",
  d: "M95.4,168.1l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C96,168.2,95.7,168.2,95.4,168.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13930",
  className: "st1",
  d: "M100,170.8l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C100.6,170.9,100.3,170.9,100,170.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13931",
  className: "st1",
  d: "M104.6,173.4l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C105.3,173.6,104.9,173.6,104.6,173.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13932",
  className: "st1",
  d: "M109.3,176.1l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C109.9,176.3,109.6,176.3,109.3,176.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13933",
  className: "st1",
  d: "M113.9,178.8l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C114.6,178.9,114.2,178.9,113.9,178.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13934",
  className: "st1",
  d: "M118.5,181.5l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C119.2,181.6,118.8,181.6,118.5,181.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13935",
  className: "st1",
  d: "M123.2,184.1l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C123.8,184.3,123.5,184.3,123.2,184.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13936",
  className: "st1",
  d: "M127.8,186.8l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C128.5,187,128.1,187,127.8,186.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13937",
  className: "st1",
  d: "M132.4,189.5l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C133.1,189.6,132.7,189.6,132.4,189.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13938",
  className: "st1",
  d: "M97.6,164.1l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C98.2,164.3,97.9,164.3,97.6,164.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13939",
  className: "st1",
  d: "M92.9,161.4l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C93.5,161.6,93.1,161.6,92.9,161.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13940",
  className: "st1",
  d: "M88.1,158.7l-6.4-3.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l6.5,3.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C88.8,158.9,88.4,158.9,88.1,158.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13941",
  className: "st1",
  d: "M91.4,155.4l-5.2-3c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l5.2,3 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C92.1,155.5,91.7,155.5,91.4,155.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13942",
  className: "st1",
  d: "M102.2,166.8l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C102.8,167,102.5,167,102.2,166.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13943",
  className: "st1",
  d: "M106.8,169.5l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C107.5,169.7,107.1,169.7,106.8,169.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13944",
  className: "st1",
  d: "M111.5,172.2l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C112.1,172.3,111.8,172.3,111.5,172.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13945",
  className: "st1",
  d: "M116.1,174.9l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C116.7,175,116.4,175,116.1,174.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13946",
  className: "st1",
  d: "M120.7,177.5l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C121.3,177.7,121,177.7,120.7,177.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13947",
  className: "st1",
  d: "M125.4,180.2l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C126,180.3,125.7,180.3,125.4,180.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13948",
  className: "st1",
  d: "M130,182.9l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C130.6,183,130.3,183,130,182.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13949",
  className: "st1",
  d: "M134.7,185.6l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C135.3,185.7,135,185.7,134.7,185.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13950",
  className: "st1",
  d: "M139.3,188.2l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C139.9,188.4,139.6,188.4,139.3,188.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13951",
  className: "st1",
  d: "M147.5,193l-6.6-3.8c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l6.6,3.8 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C148.2,193.1,147.8,193.1,147.5,193z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13952",
  className: "st1",
  d: "M156.5,187.8l-5.5-3.2c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l5.5,3.2 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C157.2,187.9,156.8,187.9,156.5,187.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13953",
  className: "st1",
  d: "M110.3,166.3l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C111,166.5,110.6,166.5,110.3,166.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13954",
  className: "st1",
  d: "M105.6,163.6l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C106.2,163.7,105.9,163.7,105.6,163.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13955",
  className: "st1",
  d: "M100.8,160.8l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C101.5,161,101.1,161,100.8,160.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13956",
  className: "st1",
  d: "M96.1,158.1l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C96.7,158.2,96.4,158.2,96.1,158.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13957",
  className: "st1",
  d: "M114.9,169l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C115.6,169.1,115.2,169.1,114.9,169z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13958",
  className: "st1",
  d: "M119.6,171.6l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C120.2,171.8,119.9,171.8,119.6,171.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13959",
  className: "st1",
  d: "M124.2,174.3l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C124.9,174.5,124.5,174.5,124.2,174.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13960",
  className: "st1",
  d: "M128.9,177l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C129.5,177.1,129.1,177.1,128.9,177z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13961",
  className: "st1",
  d: "M133.5,179.7l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C134.1,179.8,133.8,179.8,133.5,179.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13962",
  className: "st1",
  d: "M138.1,182.4l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C138.8,182.5,138.4,182.5,138.1,182.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13963",
  className: "st1",
  d: "M142.8,185l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C143.4,185.2,143.1,185.2,142.8,185z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13964",
  className: "st1",
  d: "M147.4,187.7l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C148,187.9,147.7,187.9,147.4,187.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13965",
  className: "st1",
  d: "M152,190.4l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C152.7,190.5,152.3,190.5,152,190.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13966",
  className: "st1",
  d: "M107.9,159.7l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C108.5,159.8,108.2,159.8,107.9,159.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13967",
  className: "st1",
  d: "M103.3,157l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C103.9,157.2,103.6,157.2,103.3,157z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13968",
  className: "st1",
  d: "M98.7,154.4l-3-1.8c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C99.3,154.5,99,154.5,98.7,154.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13969",
  className: "st1",
  d: "M94,151.7l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C94.7,151.8,94.3,151.8,94,151.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13970",
  className: "st1",
  d: "M98.8,149l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l1-0.6c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-1,0.6C99.4,149.1,99.1,149.1,98.8,149z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13971",
  className: "st1",
  d: "M104.8,152.4l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l1-0.6c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-1,0.6C105.4,152.6,105.1,152.6,104.8,152.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13972",
  className: "st1",
  d: "M109.4,155.1l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l1-0.6c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-1,0.6C110,155.2,109.7,155.2,109.4,155.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13973",
  className: "st1",
  d: "M114,157.7l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l1-0.6c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-1,0.6C114.6,157.9,114.3,157.9,114,157.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13974",
  className: "st1",
  d: "M118.6,160.4l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l1-0.6c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-1,0.6C119.2,160.5,118.9,160.5,118.6,160.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13975",
  className: "st1",
  d: "M144.2,175.2l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l1-0.6c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-1,0.6C144.9,175.3,144.5,175.3,144.2,175.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13976",
  className: "st1",
  d: "M148.8,177.8l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l1-0.6c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-1,0.6C149.5,178,149.1,178,148.8,177.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13977",
  className: "st1",
  d: "M153.4,180.5l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l1-0.6c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-1,0.6C154,180.6,153.7,180.6,153.4,180.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13978",
  className: "st1",
  d: "M158,183.1l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l1-0.6c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-1,0.6C158.6,183.3,158.3,183.3,158,183.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13979",
  className: "st1",
  d: "M112.5,162.4l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C113.2,162.5,112.8,162.5,112.5,162.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13980",
  className: "st1",
  d: "M117.1,165l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C117.8,165.2,117.4,165.2,117.1,165z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13981",
  className: "st1",
  d: "M121.8,167.7l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C122.4,167.9,122.1,167.9,121.8,167.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13982",
  className: "st1",
  d: "M126.4,170.4l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C127.1,170.5,126.7,170.5,126.4,170.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13983",
  className: "st1",
  d: "M131,173.1l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.1,0.6-0.1,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C131.7,173.2,131.3,173.2,131,173.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13984",
  className: "st1",
  d: "M135.7,175.7l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C136.3,175.9,136,175.9,135.7,175.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13985",
  className: "st1",
  d: "M140.3,178.4l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C141,178.6,140.6,178.6,140.3,178.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13986",
  className: "st1",
  d: "M145,181.1l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.6l-3,1.7C145.6,181.2,145.2,181.2,145,181.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13987",
  className: "st1",
  d: "M149.6,183.8l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3-1.7c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C150.2,183.9,149.9,183.9,149.6,183.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13988",
  className: "st1",
  d: "M86,162.7l-8.8-5.1c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l8.8,5.1 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C86.6,162.8,86.3,162.8,86,162.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13989",
  className: "st1",
  d: "M142.9,195.6l-8.8-5.1c-0.2-0.1-0.2-0.4,0.1-0.5l3-1.7c0.3-0.2,0.6-0.2,0.9,0l8.8,5.1 c0.2,0.1,0.2,0.4-0.1,0.5l-3,1.7C143.6,195.7,143.2,195.7,142.9,195.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13990",
  className: "st1",
  d: "M124.4,190.8l-3-1.7c-0.2-0.1-0.2-0.4,0.1-0.6l3.6-2c0.3-0.2,0.6-0.2,0.9,0l3,1.7 c0.2,0.1,0.2,0.4-0.1,0.5l-3.5,2.1C125.1,190.9,124.7,190.9,124.4,190.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13991",
  className: "st1",
  d: "M90.8,171.3l-4.8-2.8c-0.2-0.1-0.2-0.4,0.1-0.5l3.6-2.1c0.3-0.1,0.6-0.1,0.9,0l4.8,2.8 c0.2,0.1,0.2,0.4-0.1,0.5l-3.5,2C91.4,171.5,91.1,171.5,90.8,171.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13992",
  className: "st1",
  d: "M119.9,188.2l-4.8-2.8c-0.2-0.1-0.2-0.4,0.1-0.5l3.5-2.1c0.3-0.2,0.6-0.2,0.9,0l4.8,2.8 c0.2,0.1,0.2,0.4-0.1,0.6l-3.5,2C120.6,188.3,120.2,188.3,119.9,188.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13993",
  className: "st1",
  d: "M97.4,175.2l-4.8-2.8c-0.2-0.1-0.2-0.4,0.1-0.5l3.5-2.1c0.3-0.1,0.6-0.1,0.9,0l4.8,2.8 c0.2,0.1,0.2,0.4-0.1,0.5l-3.6,2C98.1,175.3,97.7,175.3,97.4,175.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13994",
  className: "st1",
  d: "M97.2,169.8l20.9,12.1c0.1,0,0.2,0.2,0.2,0.4c0,0,0,0,0,0c0,0.1-0.1,0.2-0.2,0.2l-3.6,2.1 c-0.3,0.2-0.6,0.2-0.9,0l-20.9-12L97.2,169.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13995",
  className: "st1",
  d: "M137.4,195.6l3.3,2c0.2,0.1,0.2,0.3-0.1,0.4l-1.4,0.8c-0.2,0.1-0.5,0.1-0.8,0l-3.3-1.9 c-0.2-0.1-0.2-0.3,0-0.4l1.4-0.8C136.8,195.5,137.1,195.5,137.4,195.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13996",
  className: "st1",
  d: "M132.7,192.9l3.3,1.9c0.2,0.1,0.2,0.3-0.1,0.4l-1.4,0.8c-0.2,0.1-0.5,0.1-0.8,0l-3.4-1.9 c-0.2-0.1-0.2-0.3,0.1-0.4l1.4-0.8C132.2,192.8,132.5,192.8,132.7,192.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13997",
  className: "st1",
  d: "M128.1,190.2l3.4,1.9c0.2,0.1,0.2,0.3-0.1,0.4l-1.4,0.8c-0.2,0.1-0.5,0.1-0.8,0l-3.3-1.9 c-0.2-0.1-0.2-0.3,0-0.4l1.4-0.8C127.5,190.1,127.8,190.1,128.1,190.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13998",
  className: "st1",
  d: "M135.3,191.4l3.3,1.9c0.2,0.1,0.2,0.3-0.1,0.4l-1.4,0.8c-0.2,0.1-0.5,0.1-0.8,0l-3.4-1.9 c-0.2-0.1-0.2-0.3,0.1-0.4l1.4-0.8C134.7,191.3,135,191.3,135.3,191.4z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2007"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13999",
  className: "st4",
  d: "M153.6,139.2l-25-14.4l0.3-1.6l25,14.4L153.6,139.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14000",
  className: "st4",
  d: "M144.6,142l-17.4-10.1l0.3-1.6l17.4,10.1L144.6,142z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14001",
  className: "st10",
  d: "M143,137.1l-15.1-8.7l0.3-1.6l15.1,8.7L143,137.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14002",
  className: "st3",
  d: "M152.9,142.8l-7.5-4.4l0.3-1.6l7.5,4.4L152.9,142.8z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2008"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14003",
  className: "st3",
  d: "M139.8,123.1c-0.2,0.5-0.8,0.7-1.2,0.5l-0.1-0.1c-0.5-0.3-0.7-0.9-0.5-1.5 c0.2-0.5,0.7-0.7,1.2-0.5c0,0,0,0,0,0l0.1,0.1C139.8,122,140,122.6,139.8,123.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14004",
  className: "st4",
  d: "M143,125c-0.2,0.5-0.8,0.7-1.2,0.5c0,0-0.1,0-0.1-0.1c-0.5-0.3-0.7-0.9-0.5-1.5 c0.2-0.5,0.8-0.7,1.2-0.5l0.1,0.1C143,123.8,143.3,124.5,143,125z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14005",
  className: "st3",
  d: "M146.3,126.9c-0.2,0.5-0.8,0.7-1.2,0.5l-0.1-0.1c-0.5-0.3-0.7-0.9-0.5-1.5 c0.2-0.5,0.8-0.7,1.2-0.5c0,0,0,0,0,0l0.1,0.1C146.3,125.7,146.5,126.3,146.3,126.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14006",
  className: "st10",
  d: "M149.5,128.8c-0.2,0.5-0.8,0.7-1.2,0.5l-0.1-0.1c-0.5-0.3-0.7-0.9-0.5-1.5 c0.2-0.5,0.8-0.7,1.2-0.5c0,0,0,0,0,0l0.1,0.1C149.5,127.6,149.7,128.2,149.5,128.8z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2012"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2010"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14007",
  className: "st3",
  d: "M153.5,62.6l-1.3-0.7v-1.8c-0.1-2.2-1.3-4.2-3.1-5.4l-9.7-5.6c-1.7-1-3.1-0.2-3.1,1.8v1.8 L135,52v-1.8c0-2.8,2-3.9,4.4-2.5l9.7,5.6c2.6,1.7,4.2,4.5,4.4,7.6V62.6z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_14008",
  className: "st3",
  d: "M149.1,65.2l4.4-2.5l-0.8-3.1l-1.2-3.1c0,0-2.1-2.4-2.3-2.4s-5.9-3.3-5.9-3.3l-4.8-3.5 l-2.3,0.1l-4.2,2.4l3.1,1.3c0,0,1.7,0.9,2.1,1c0.8,0.5,1.5,1.1,2.1,1.7l2.1,0.8l0.4-0.1l3.7,2.6l1.2,0.5l0.6,1l1,2.8L149.1,65.2 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14009",
  className: "st2",
  d: "M136.3,52.7l-4.4,2.5c0,0-0.3-2.8-0.3-2.9s1-1.4,1-1.4l2.4-0.5l1.9,1.4l-0.6-0.2l-0.2,0.2 l0.3,0.5L136.3,52.7z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2011"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14010",
  className: "st1",
  d: "M149.1,65.2l-1.3-0.7v-1.8c-0.1-2.2-1.3-4.2-3.1-5.4l-9.7-5.6c-1.7-1-3.1-0.2-3.1,1.8v1.8 l-1.3-0.7v-1.8c0-2.8,2-3.9,4.4-2.5l9.7,5.6c2.6,1.7,4.2,4.5,4.4,7.6V65.2z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2015"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2013"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14011",
  className: "st3",
  d: "M197.6,62.6l-1-0.6l-1.2,0.8l2.2,1.2c1.8,1.2,3,3.2,3.1,5.4v1.8l1.3,0.7v-1.8 C201.7,67.2,200.1,64.3,197.6,62.6z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_14012",
  className: "st3",
  d: "M199.8,65.9c0,0-2.1-2.3-2.3-2.4s-0.8-0.4-1.7-0.9c-1.4,0.9-2.8,1.7-4.2,2.5l2.2,1.5 l1.2,0.5l0.6,1l1,2.8l0.8,3.6l4.4-2.5l-0.9-3.1L199.8,65.9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2014"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14013",
  className: "st1",
  d: "M193.2,66.6c1.8,1.2,3,3.2,3.1,5.4v1.8l1.3,0.7v-1.8c-0.2-3.1-1.8-5.9-4.4-7.6l-0.8-0.5 l-1.3,0.7L193.2,66.6z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2019"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2017"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14014",
  className: "st11",
  d: "M277.1,31.9l-14.7-8.5c-0.2-0.2-0.5-0.2-0.8-0.1l0,0l-1.4,0.8l1,0.4v10.7 c0,0.9,0.5,1.7,1.2,2.2l14,8.1v1.2l1.4-0.8l0,0c0.3-0.2,0.4-0.6,0.4-0.9V34.2C278.3,33.3,277.9,32.4,277.1,31.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14015",
  className: "st12",
  d: "M275.7,46.8L261,38.3c-0.7-0.5-1.2-1.4-1.2-2.2V25.2c0-0.9,0.5-1.3,1.2-0.9l14.7,8.5 c0.7,0.5,1.2,1.4,1.2,2.2v10.9C276.9,46.8,276.4,47.2,275.7,46.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14016",
  className: "st4",
  d: "M276.1,32.6l-14.7-8.5c-0.3-0.2-0.6-0.2-0.9,0c0.2,0,0.4,0,0.5,0.1l14.7,8.5 c0.7,0.5,1.2,1.4,1.2,2.3v10.9c0,0.3-0.1,0.6-0.3,0.8c0.4,0,0.7-0.4,0.7-1V34.9C277.2,34,276.8,33.1,276.1,32.6z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2018"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14017",
  className: "st4",
  d: "M266,34.6c0,0.6-0.4,0.9-1,0.6c-0.6-0.4-1-1-1-1.7c0-0.6,0.5-0.9,1-0.6 C265.6,33.2,265.9,33.9,266,34.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14018",
  className: "st4",
  d: "M269,36.3c0,0.6-0.4,0.9-1,0.6c-0.6-0.4-1-1-1-1.7c0-0.6,0.4-0.9,1-0.6 C268.6,35,268.9,35.6,269,36.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14019",
  className: "st4",
  d: "M272,38.1c0,0.6-0.5,0.9-1,0.6c-0.6-0.4-1-1-1-1.7c0-0.6,0.4-0.9,1-0.6 C271.6,36.7,271.9,37.4,272,38.1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2022"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2020"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14020",
  className: "st1",
  d: "M268.8,18.2l-14.7-8.5c-0.2-0.2-0.5-0.2-0.8-0.1l0,0l-1.4,0.8l1,0.4v10.7 c0,0.9,0.4,1.7,1.2,2.2l14,8.1v1.2l1.4-0.8l0,0c0.3-0.2,0.4-0.6,0.4-0.9V20.5C270,19.6,269.5,18.7,268.8,18.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14021",
  className: "st3",
  d: "M267.4,33.1l-14.7-8.5c-0.7-0.5-1.2-1.4-1.2-2.2V11.5c0-0.9,0.5-1.3,1.2-0.9l14.7,8.5 c0.7,0.5,1.2,1.4,1.2,2.2v10.9C268.5,33.1,268,33.5,267.4,33.1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14022",
  className: "st4",
  d: "M267.7,18.9L253,10.4c-0.3-0.2-0.6-0.2-0.9,0c0.2,0,0.4,0,0.6,0.2l14.7,8.5 c0.7,0.5,1.2,1.4,1.2,2.2v10.9c0,0.3-0.1,0.6-0.3,0.8c0.4,0,0.6-0.4,0.6-1V21.1C268.9,20.2,268.4,19.4,267.7,18.9z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2021"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14023",
  className: "st4",
  d: "M257.6,20.9c0,0.6-0.5,0.9-1,0.6c-0.6-0.4-1-1-1-1.7c0-0.6,0.4-0.9,1-0.6 C257.2,19.5,257.6,20.2,257.6,20.9z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14024",
  className: "st4",
  d: "M260.6,22.6c0,0.6-0.4,0.9-1,0.6c-0.6-0.4-1-1-1-1.7c0-0.6,0.5-0.9,1-0.6 C260.2,21.2,260.6,21.9,260.6,22.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14025",
  className: "st4",
  d: "M263.6,24.3c0,0.6-0.4,0.9-1,0.6c-0.6-0.4-1-1-1-1.7c0-0.6,0.5-0.9,1-0.6 C263.2,23,263.6,23.6,263.6,24.3z"
})))), /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-close-circle",
  className: "st12",
  d: "M55.5,90.7c-8.9,0-16.1,7.2-16.1,16.1c0,8.9,7.2,16.1,16.1,16.1 s16.1-7.2,16.1-16.1c0,0,0,0,0,0l0,0C71.6,97.9,64.4,90.7,55.5,90.7L55.5,90.7L55.5,90.7z M59.6,112.6l-4.1-4l-4.1,4 c-0.5,0.5-1.3,0.5-1.7,0c0,0,0,0,0,0c-0.5-0.5-0.5-1.3,0-1.8l4.1-4.1l-4.1-4c-0.5-0.5-0.4-1.3,0.1-1.8c0.5-0.4,1.2-0.4,1.6,0 l4.1,4.1l4.1-4.1c0.5-0.5,1.3-0.4,1.8,0.1c0.4,0.5,0.4,1.2,0,1.6l-4.1,4.1l4.1,4.1c0.5,0.5,0.5,1.3,0,1.8S60.1,113.1,59.6,112.6 L59.6,112.6L59.6,112.6L59.6,112.6z"
}))));
export { SvgUnhandledError as ReactComponent };